import { ReactNode } from 'react';
import { Channel as ChannelType } from 'stream-chat';
import { Window } from 'stream-chat-react';

interface InnerChannelContentProps {
  channel?: ChannelType;
  children: ReactNode;
}

/**
 * A slim wrapper that provides the Window component for Stream Chat.
 * This should be used inside a ChannelProvider to ensure the Channel context is available.
 */
export const InnerChannelContent = ({
  channel,
  children,
}: InnerChannelContentProps) => {
  return <Window>{channel && children}</Window>;
};
